import Panel from "@scene/objects/panel";
import { initState as initDimensionState, imperialState, metricState } from "@reducers/selectors/dimension";
import { APP_TYPES } from "@config";
import { mergeDeep } from "@services/helper.service";

export const GeneralCalculationState = {
  type: Panel.types.SQUARE,
  isClosed: false,
  width: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.lx,
  height: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.ly,
  depth: initDimensionState[APP_TYPES.GENERAL_CALCULATION].basePlate.tfix,
  sideLength: 150,
  color: 0x98cbea,
  standOff: {
    value: initDimensionState[APP_TYPES.GENERAL_CALCULATION].standOff.standOffDimensionL
  },
  animate: {
    move: {
      z: {
        active: false,
        fixed: true,
        value: null,
        units: null
      },
      x: {
        active: false,
        fixed: true,
        value: null,
        units: null
      },
      y: {
        active: false,
        fixed: true,
        value: null,
        units: null
      }
    },
    rotate: {
      z: {
        active: false,
        fixed: true,
        value: null,
        units: null
      },
      x: {
        active: false,
        fixed: true,
        value: null,
        units: null
      },
      y: {
        active: false,
        fixed: true,
        value: null,
        units: null
      }
    }
  },
  vertices: {
    count: 4,
    positions: []
  },
  center: {
    x: 0,
    y: 0
  }
};

export function getGeneralCalcDefault(isImperial) {
  let unitState = isImperial ? imperialState : metricState;
  return mergeDeep(GeneralCalculationState, {
    width: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.lx,
    height: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.ly,
    depth: unitState[APP_TYPES.GENERAL_CALCULATION].basePlate.tfix,
  });
}



// WEBPACK FOOTER //
// ./src/reducers/options/panel/defaults/generalCalculation.js